import StepIndicator from '../StepIndicator';
import { useBoolean } from 'usehooks-ts';
import { ControlledNameField } from '../../ControlledNameField';
import { InfoButton, Stack } from 'ui-components';
import { ControlledCheckBox } from 'controlled-components';
import { twJoin } from 'tailwind-merge';
import { ControlledValidationPhoneField } from '../../ControlledValidationPhoneField';
import { useCheckoutStore } from '../checkoutStore';
import { useFormContext } from 'react-hook-form';

export function Step3(): React.ReactElement {
  const { setValue } = useFormContext();
  const selectedStore = useCheckoutStore((state) => state.selectedStore);
  const manual = useCheckoutStore((state) => state.manual);
  const scheduled = useCheckoutStore((state) => state.scheduled);
  const { setTrue: setPhoneValidated, value: phoneValidated } = useBoolean(false);
  const setSelectedCoupon = useCheckoutStore((state) => state.setSelectedCoupon);

  const isDisabled = !selectedStore || (!selectedStore?.slotsAvailable && !scheduled);

  const finishedPhoneValidation = () => {
    setPhoneValidated();
    setValue('couponCode', ''); // Reset coupon code after phone validation
    setSelectedCoupon(undefined); // Reset selected coupon after phone validation
  };

  return (
    <>
      <StepIndicator disabled={isDisabled} index={3}>
        Deine Details
      </StepIndicator>

      <Stack gap={2} className={isDisabled ? 'opacity-50' : ''}>
        <ControlledValidationPhoneField
          disabled={isDisabled}
          placeholder="Telefonnummer"
          onSuccessfulValidation={finishedPhoneValidation}
        />

        <Stack
          gap={2}
          className={twJoin(
            'duration-200 ease-out transition transform z-10',
            phoneValidated ? 'opacity-100' : 'opacity-0 h-0',
          )}
        >
          <ControlledNameField
            align="left"
            placeholder="Vorname"
            autoComplete={manual ? 'off' : 'name'}
            disabled={isDisabled}
            noLabel
          />

          {Boolean(selectedStore?.service.kidsPrice) && (
            <ControlledCheckBox name="kidCustomer" label="Kinderhaarschnitt" />
          )}

          <Stack gap={2} direction="row">
            <ControlledCheckBox name="silentBooking" label="Silent Cut" />
            <InfoButton
              title="Silent cut"
              text="Nach der Beratung und Besprechung des Schnitts geniesse ich meinen Schnitt heute gerne in Ruhe und verzichte auf Smalltalk."
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
